import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=324b2529&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=324b2529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b2529",
  null
  
)

export default component.exports